module.exports = __webpack_public_path__ + "img/img_about_design02.259eacb0.png";